import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Reports from "@/pages/Reports";
import Upload from "@/pages/Upload";
import Export from "@/pages/Export";
import Email from "@/pages/Email";
import Admin from "@/pages/Admin";
import Audit from "@/pages/Audit";
import DataFixer from "@/pages/DataFixer";
import Targets from "@/pages/Targets";
import Chat from "@/pages/Chat";
import MonthlySales from "@/pages/MonthlySales";

const Protected = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm tracking-widest uppercase">
        Loading Maison Analytica…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/monthly" element={<MonthlySales />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/data-fixer" element={<DataFixer />} />
              <Route path="/targets" element={<Targets />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/export" element={<Export />} />
              <Route path="/email" element={<Email />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/audit" element={<Audit />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
